<template>
<div class="main">
    <c-panel title="PERMISSÕES DE ACESSO" titleIcon="fas fa-user-shield">

        <div v-loading="carregando">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Marque quais perfis podem abrir cada tela do sistema."
                description="A marcação vale para o menu e para o acesso direto pelo endereço — quem não tem a tela liberada não consegue usá-la nem digitando a URL. O perfil NTI - PMVC não aparece aqui porque enxerga todas as telas por definição."></el-alert>

            <el-row :gutter="10" class="u-mb-15">
                <el-col :xs="24" :sm="14" :md="16">
                    <el-input v-model="busca" clearable placeholder="Pesquisar tela...">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="10" :md="8" class="u-text-right">
                    <el-button plain icon="el-icon-refresh-left" @click="descartar" :disabled="!alterado">DESCARTAR</el-button>
                    <el-button type="primary" icon="el-icon-check" @click="salvar" :disabled="!alterado" :loading="salvando">SALVAR</el-button>
                </el-col>
            </el-row>

            <div v-for="grupo in gruposFiltrados" :key="grupo.nome" class="u-mb-25">

                <h4 class="u-mb-10">{{ grupo.nome }}</h4>

                <div class="container-table" style="overflow-x: auto;">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="min-width: 210px;">Tela</th>
                                <th v-for="p in perfis" :key="p.tipo" class="u-text-center coluna-perfil" :title="p.nome">
                                    <span class="rotulo-perfil">{{ p.curto }}</span>
                                    <br>
                                    <el-checkbox :indeterminate="parcialColuna(grupo, p.tipo)"
                                        :value="todaColuna(grupo, p.tipo)"
                                        @change="marcarColuna(grupo, p.tipo, $event)"></el-checkbox>
                                </th>
                                <th style="width: 90px;" class="u-text-center">Padrão</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in grupo.itens" :key="item.recurso">
                                <td>
                                    {{ item.titulo }}
                                    <div class="rota-tela">{{ item.rota }}</div>
                                </td>
                                <td v-for="p in perfis" :key="p.tipo" class="u-text-center">
                                    <el-checkbox v-model="item.perfis[p.tipo]" @change="alterado = true"></el-checkbox>
                                </td>
                                <td class="u-text-center">
                                    <el-button v-if="foraDoPadrao(item)" @click="restaurar(item)"
                                        type="info" icon="el-icon-refresh-left" size="mini" plain
                                        title="Voltar ao padrão do sistema"></el-button>
                                    <span v-else class="u-text-muted" title="Está no padrão do sistema">—</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div v-if="!carregando && !gruposFiltrados.length" class="u-text-center u-mt-25">
                Nenhuma tela encontrada.
            </div>

            <div class="u-text-right u-mt-15">
                <el-button plain icon="el-icon-refresh-left" @click="descartar" :disabled="!alterado">DESCARTAR</el-button>
                <el-button type="primary" icon="el-icon-check" @click="salvar" :disabled="!alterado" :loading="salvando">SALVAR</el-button>
            </div>
        </div>

    </c-panel>
</div>
</template>

<script>
export default {
    name: 'PermissaoRecurso',

    data: () => ({
        carregando: false,
        salvando: false,
        alterado: false,
        busca: '',
        perfis: [],
        recursos: []
    }),

    created () {
        this.carregar()
    },

    computed: {

        // Agrupa as telas pelo mesmo agrupamento que elas têm no menu, para o
        // SMED reconhecer o que está marcando.
        gruposFiltrados () {

            const termo = this.normalizar(this.busca)
            const grupos = []

            for (const item of this.recursos) {

                if (termo && !this.normalizar(item.titulo).includes(termo) &&
                    !this.normalizar(item.grupo).includes(termo)) continue

                let grupo = grupos.find(g => g.nome === item.grupo)

                if (!grupo) {
                    grupo = { nome: item.grupo, itens: [] }
                    grupos.push(grupo)
                }

                grupo.itens.push(item)
            }

            return grupos
        }
    },

    methods: {

        normalizar (s) {
            return (s || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()
        },

        carregar () {

            this.carregando = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/recurso/matriz`, this.$store.getters.getHeaderAuth)
                .then(response => {

                    this.perfis = response.data.perfis || []
                    this.recursos = response.data.recursos || []
                    this.alterado = false
                })
                .finally(() => { this.carregando = false })
        },

        descartar () {
            this.carregar()
        },

        // Uma tela está fora do padrão quando a marcação atual difere do
        // perfis_padrao do catálogo — inclui alterações ainda não salvas.
        foraDoPadrao (item) {

            for (const p of this.perfis) {

                const padrao = (item.padrao || []).includes(p.tipo)
                if (!!item.perfis[p.tipo] !== padrao) return true
            }

            return false
        },

        todaColuna (grupo, tipo) {
            return grupo.itens.length > 0 && grupo.itens.every(i => i.perfis[tipo])
        },

        parcialColuna (grupo, tipo) {
            const marcados = grupo.itens.filter(i => i.perfis[tipo]).length
            return marcados > 0 && marcados < grupo.itens.length
        },

        marcarColuna (grupo, tipo, valor) {

            for (const item of grupo.itens)
                this.$set(item.perfis, tipo, !!valor)

            this.alterado = true
        },

        restaurar (item) {

            this.$confirm(`Voltar "${item.titulo}" ao padrão do sistema?`, 'Restaurar padrão', {
                confirmButtonText: 'Restaurar', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {

                this.carregando = true

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/recurso/restaurar/${item.recurso}`, {}, this.$store.getters.getHeaderAuth)
                    .then(response => {

                        if (response.data.erro) {
                            this.$message.error(response.data.erro)
                            this.carregando = false
                            return
                        }

                        this.$message.success('Padrão restaurado.')
                        this.carregar()
                    })
                    .catch(() => { this.carregando = false })

            }).catch(() => {})
        },

        salvar () {

            this.salvando = true

            const itens = this.recursos.map(i => ({ recurso: i.recurso, perfis: i.perfis }))

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/recurso/salvar`, { itens }, this.$store.getters.getHeaderAuth)
                .then(response => {

                    if (response.data.erro) {
                        this.$message.error(response.data.erro)
                        return
                    }

                    this.alterado = false

                    this.$message.success('Permissões salvas. Cada usuário passa a ver o novo menu no próximo acesso.')
                    this.carregar()
                })
                .finally(() => { this.salvando = false })
        }
    }
}
</script>

<style scoped>
.coluna-perfil {
    min-width: 84px;
    vertical-align: top;
}
.rotulo-perfil {
    font-size: 11px;
    display: inline-block;
    line-height: 14px;
}
.rota-tela {
    font-size: 11px;
    color: #909399;
}
.u-text-muted {
    color: #c0c4cc;
}
</style>
